// @flow

import * as React from 'react';
import glamorous, { Span } from 'glamorous';
import { Power4 } from 'gsap';
import moment from 'moment';
import Tappable from 'app/components/commons/Tappable';
import t from 'app/utils/translate';
import Glyph from 'app/components/commons/Glyph';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import GlobalPointsDropDown from './GlobalPointsDropDown';

type Props = {
  updatedTime: string,
};

type State = {
  isOpen: boolean,
};

const ListHeader = glamorous.div(({ theme }) => ({
  backgroundColor: theme.color.basis1,
  display: 'flex',
  fontSize: theme.fontSize.small,
  justifyContent: 'space-between',
  paddingLeft: theme.spacing.small,
  paddingRight: theme.spacing.small,
  paddingTop: theme.spacing.xsmall,
  paddingBottom: theme.spacing.xsmall,
  textTransform: 'uppercase',
  width: '100%',
}));

const InfoButton = glamorous(Glyph)({
  marginTop: -2,
  paddingLeft: 6,
});

const DateUpdated = glamorous.span(({ theme }) => ({
  color: theme.color.basis5,
  fontSize: theme.fontSize.tiny,
  fontWeight: theme.fontWeight.normal,
  fontStyle: 'italic',
}));

class LeaderboardHeader extends React.Component<Props, State> {
  props: Props;

  state: State = {
    isOpen: false,
  };

  toggleDrawer = () => {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }));
  }

  render() {
    const { updatedTime } = this.props;
    const { isOpen } = this.state;
    const dateUpdated = moment(updatedTime).calendar(null, {
      sameDay: `[${t('Today')}] hh:mma`,
      lastDay: `[${t('Yesterday')}] hh:mma`,
      lastWeek: `[${t('Last')}] dddd`,
      sameElse: 'll',
    });

    return (
      <div>
        <ListHeader>
          <div>
            <Span paddingRight={6}>
              {t('Leaderboard')}
            </Span>
            <DateUpdated>
              {`(${t('Updated')} ${dateUpdated})`}
            </DateUpdated>
          </div>
          <Tappable onTap={this.toggleDrawer}>
            {t('Global Score')}
            <InfoButton size="small" icon="information-circled" />
          </Tappable>
        </ListHeader>
        <AnimatedGroup
          onEnter={Enter.grow({ duration: 0.3, ease: Power4.easeOut })}
          onLeave={Leave.shrink({ duration: 0.3, ease: Power4.easeOut })}
        >
          {isOpen && (
            <GlobalPointsDropDown
              key="content"
            />
          )}
        </AnimatedGroup>
      </div>
    );
  }
}

export default LeaderboardHeader;
